import { createContext, useContext, useState } from 'react';
import { modelProviders } from '../config';

export const modelContext = createContext();

export const ModelProvider = ({ children }) => {

    const defaultModelProvider = process.env.REACT_APP_DEFAULT_MODEL_PROVIDER || modelProviders[0];

    const [modelProvider, setModelProvider] = useState(defaultModelProvider);

    return (
        <modelContext.Provider value={ [modelProvider, setModelProvider] }>
            {children}
        </modelContext.Provider>
    );
};

export function useModel() {
    return useContext(modelContext);
}
